import type { GQLExtension } from '../web-client/graphql/types';

export const isBodiedLayout = (layout: unknown): boolean =>
	layout === 'bodied' || layout === 'inline-bodied';

export const getExtensionType = (
	extension: Pick<GQLExtension, 'properties'>,
): 'extension' | 'inlineExtension' | 'bodiedExtension' => {
	const { properties } = extension;

	if (isBodiedLayout(properties?.layout)) {
		return 'bodiedExtension';
	} else if (properties?.layout === 'inline') {
		return 'inlineExtension';
	}
	return 'extension';
};
